import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/home/ubuntu/download/69858b98921dc90014dd9abd/carrizoperezlaw/src/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69858b98921dc90014dd9abd/carrizoperezlaw/src/styles/index.css");
